// @flow

import React from 'react'
import styled from 'styled-components'
import noScroll from 'no-scroll'
import Colors from 'components/styles/colors'
import { mediaMax } from 'components/styles/_media'

const ModalBg = styled.div`
  display: none;
  opacity: 0;
  transition: all 0.3s;

  &[data-modal-active='active'] {
    position: fixed;
    display: block;
    opacity: 1;
    visibility: visible;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 2000;
    background: rgba(0, 0, 0, 0.6);
    transition: all 0.3s;
  }
`
const ModalContentWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`
const ModalContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow-y: auto;
  height: 100%;
  background-color: ${Colors.white};
  ${mediaMax.desktop`
    width: 100%;
  `};
`
const ModalCloseWrapper = styled.a`
  position: absolute;
  display: inline-block;
  top: 16px;
  right: 24px;
  cursor: pointer;
  z-index: 1;
  color: ${Colors.grayD};
  ${mediaMax.desktop`
    right: 12px;
  `} &:hover {
    color: ${Colors.grayD};
  }
`
const ModalClose = styled.span`
  position: relative;
  display: inline-block;
  font-family: Arial, sans-serif;
  display: block;
  font-size: 60px;
  line-height: 0.6;
  text-align: center;
  ${mediaMax.desktop`
    font-size: 40px;
  `};
`
const ModalCloseText = styled.span`
  font-size: 10px;
`

export type PropTypes = {
  children: string,
  isScrollLock: boolean,
  onClickClose: Function,
}

export default class Modal extends React.Component<*> {
  props: PropTypes

  componentDidUpdate() {
    if (this.props.isScrollLock) {
      noScroll.on()
    }
  }

  componentWillUnmount() {
    if (this.props.isScrollLock) {
      noScroll.off()
    }
  }

  render() {
    const { children, onClickClose } = this.props

    return (
      <ModalBg data-modal-active="active">
        <ModalContentWrapper>
          <ModalContent>
            <ModalCloseWrapper onClick={onClickClose}>
              <ModalClose>×</ModalClose>
              <ModalCloseText>{i18n.t('page.search.cancel')}</ModalCloseText>
            </ModalCloseWrapper>
            {children}
          </ModalContent>
        </ModalContentWrapper>
      </ModalBg>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/Modal.jsx